import { GET_ALL_SALEORDER_REQUEST, GET_ALL_SALEORDER_SUCCESS, GET_ALL_SALEORDER_ERROR } from "../actions/types";
export default function (state = [], action) {
	const { type, payload } = action;
	switch (type) {
		case GET_ALL_SALEORDER_REQUEST:
			return {
				loading: true,
			};
		case GET_ALL_SALEORDER_SUCCESS:
			return {
				...state,
				loading: false,
				payload
			};
		case GET_ALL_SALEORDER_ERROR:
			return {
				...state,
				loading: false,
				payload,
			};

		default:
			return state;
	}
}